// extracted by mini-css-extract-plugin
module.exports = {"form":"Auth_form__xZKl9","error":"Auth_error__TVoWJ"};